<script>
import Label from './Label.vue'
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "ckeditor5-build-classic-with-font";
import { v4 as uuidv4 } from 'uuid';

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        type: Array,
        required: true,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        selectedItem: {
        type: Object,
        required: false
        },
        last_updated: {
            type: Object,
            required: false
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
        Label,       
        ckeditor: CKEditor.component,
    },
    data() {
        return {
            value: this.item_value,
            isModalVisible: false,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: ['heading', '|', 'fontColor', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'insertTable', 'undo', 'redo'],
                heading: {
                options: [
                    { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                    { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                    { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                    { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                    { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' }
                ]
                },
                table: {
                contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
                },
                fontColor: {
                colors: [
                    {
                    color: '#005EB8',
                    label: 'Blue'
                    },
                    {
                    color: '#FF2E2E',
                    label: 'Red'
                    },
                    {
                    color: '#4F535B',
                    label: 'Main Grey'
                    }
                ]
                },
                link: {
                decorators: {
                    toggleDownloadable: {
                    mode: 'manual',
                    label: 'Downloadable',
                    attributes: {
                        download: 'file'
                    }
                    },
                    openInNewTab: {
                    mode: 'manual',
                    label: 'Open in a new tab',
                    attributes: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                    }
                }
                }
            },
            subgroup: ''
        };
    },    
    methods: {
        toggleModal() {
            this.isModalVisible = !this.isModalVisible;
        },
        addSubGroup() {
            this.value.push({
                id: uuidv4(),
                title: this.subgroup,
                description: '',
            });
            this.subgroup = ''
        },
        removeSubGroup(val) {
            this.value = this.value.filter(x => x.id != val.id)
        }
    },
    computed: {
        display_none_check: {
            get: function () {
                return this.selectedItem ? JSON.stringify(this.selectedItem[this.item.displayOn]) == this.item.displayOnValue ? true : false : false
            },
            set: function (newValue) {
                return newValue
            }
        },
        // subgroup: {
        //     get() {

        //     }
        // }
    },
    watch: {
        last_updated: {
            handler(val) {
                if(val && this.item.displayOn && val.key == this.item.displayOn) {                    
                    this.display_none_check = JSON.stringify(val.value) == this.item.displayOnValue ? true : false;
                }
            },
            deep: true
        },
        item_value: {
            handler(val) {
                this.value = val;
            },
            deep: true
        },
        value(val) {
            this.updateValue(this.item_key, val);
        }
    }
};
</script>
<template>
    <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check}">
        <Label :item="item" :model_length="validation.$model.length" :toggleModal="toggleModal"/>
        <b-modal
            v-model="isModalVisible"
            style="letter-spacing: 2em;"
            id="modal-center-subgroup"
            centered
            title="Manage Sub-Groups"
            title-class="font-18"
            hide-footer
        >
            <div class="d-flex mb-3">
            <input v-model="subgroup" type="text" class="form-control mr-2" />  
            <button class="btn btn-primary" @click="addSubGroup(); $bvModal.hide('modal-center-subgroup')">Add</button>
            </div>
        </b-modal>
        <div v-for="(sg, i) of value" :key="sg.id">
            <div class="d-flex">
                <label
                class="pr-2 my-2 align-self-sm-center font-theme-black-color font-weight-medium"
                :for="sg.id">Sub-group {{i + 1}}<span> *</span></label>
                <img :id="sg.id" variant="primary" class="align-self-center" src="@/assets/images/info.svg" alt="">
                <b-tooltip :target="sg.id">Enter Sub-group</b-tooltip>
                <a class="font-size-14 mb-2 font-weight-medium ml-auto align-self-sm-center" role="button" style="color: #da3f3f"
                v-on:click="removeSubGroup(sg)">Remove</a>      
            </div>
            <div>
            <input
                v-model="sg.title"
                type="text"
                class="form-control mb-2"
            />
            <ckeditor v-model="sg.description" :editor="editor" :config="editorConfig" :id="sg.id"></ckeditor>
            </div>
        </div>
        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>



